import { useCallback } from 'react';

/**
 * Manages audio-specific controls
 * - Toggles playback
 * - Handles keyboard interaction (Enter/Space)
 */
export const useAudioControls = (isPlaying, play, pause) => {
   const togglePlayback = useCallback(() => {
      if (isPlaying) {
         pause();
      } else {
         play();
      }
   }, [isPlaying, play, pause]);

   const handleKeyDown = useCallback(
      e => {
         if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            togglePlayback();
         }
      },
      [togglePlayback],
   );

   return {
      togglePlayback,
      handleKeyDown,
   };
};
